import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService, ErrorHandlerService, ConfirmationDialogButtons } from 'yt-ng-framework';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { Subject } from 'rxjs';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { RobaView } from 'src/app/lookups/roba/roba-view';
import { HttpErrorResponse } from '@angular/common/http';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { Validators } from '@angular/forms';
import { KomitentVoziloView } from 'src/app/lookups/komitent-vozilo/komitent-vozilo-view';
import { EPrijemnicaPrevoz } from './eprijemnica-prevoz';
import { EPrijemnicaService } from './eprijemnica-service';

@Component({
    selector: 'yt-eprijemnica-prevoz-update',
    templateUrl: './eprijemnica-prevoz-update.component.html'
})
export class EPrijemnicaPrevozUpdateComponent
    extends BaseUpdateComponent<EPrijemnicaPrevoz>
    implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    varConfig = var_config;
    pretplacenNaPromene: boolean = false;
    izlazna: boolean = true;
    parameterList: List<QueryParameter> = List([]);
    PrevoznikID: QueryParameter = new QueryParameter();
    razvoj: boolean=true;

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected prijemnicaService: EPrijemnicaService,
        protected decimalPipe: DecimalPipe,
        protected userService: UserService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modalService: ModalService,
        protected errorService: ErrorHandlerService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);

    }

    ngOnInit() {
        super.ngOnInit();

        this.IDProcessed
            .subscribe((value) => {
                if (value){                    
                    this.baseFormGroup.disable();
                    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                }
            })
    }


    ngOnDestroy() { }

}